export enum PurchaseSubscriptionState {
  addDevice,
  addPaymentMethod,
  purchase,
  error,
  success,
}
